<template>
  <div>
    <b-card id="wts-card" no-body small>
      <b-tabs id="wts-tabs" v-model="tabIndex">
        <b-tab id="wts-tab">
          <template slot="title">
            Support Ticket
            <span class="badge badge-pill badge-primary">{{supportTicket}}</span>
          </template>
          <wtForm>
            <template slot="left">
              <SupportTicketFilter
                :ticketTypes="ticketTypes"
                :ticketClassification="ticketClassification"
                :ticketPriority="ticketPriority"
                :ticketStatus="ticketStatus"
                :productType="productType"
                :productModule="productModule"
                :productFunction="productFunction"
              />
            </template>

            <template slot="right">
              <SupportTicket
                @supportTicketSelected="supportTicket = $event"
                :ticketTypes="ticketTypes"
                :ticketClassification="ticketClassification"
                :ticketPriority="ticketPriority"
                :ticketStatus="ticketStatus"
                :productType="productType"
                :productModule="productModule"
                :productFunction="productFunction"
              />
            </template>
          </wtForm> 
        </b-tab>  

        <!-- SUPPORT TICKET ACTIVITY -->
        <b-tab id="wts-tab" >
          <template slot="title">
            Activity <span class="badge badge-pill badge-primary"></span> 
          </template> 
          <wtForm >
            <template slot="left" >
              <SupportTicketActivityFilter/>
            </template>

            <template slot="right">
              <SupportTicketActivity/>
            </template>
          </wtForm> 
        </b-tab> 


        <!-- SUPPORT TICKET HISTORIC -->
        <b-tab id="wts-tab" >
          <template slot="title">
            Historic of Comunication <span class="badge badge-pill badge-primary"></span> 
          </template> 
          <wtForm >
            <template slot="left" >
              <SupportTicketHistoricFilter/>
            </template>

            <template slot="right">
              <SupportTicketHistoric/>
            </template>
          </wtForm> 
        </b-tab> 

        <!-- SUPPORT TICKET INTERNSHIP -->
        <b-tab id="wts-tab" >
          <template slot="title">
            Internship <span class="badge badge-pill badge-primary"></span> 
          </template> 
          <wtForm >
            <template slot="right">
              <SupportTicketInternship/>
            </template>
          </wtForm> 
        </b-tab> 
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/** COMPONENTS - LAYOUT **/
import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import SupportTicket from "@/modules/support_ticket_ds/internal/support_ticket/SupportTicket";
import SupportTicketFilter from "@/modules/support_ticket_ds/internal/support_ticket/SupportTicketFilter";

import SupportTicketActivity from "@/modules/support_ticket_ds/internal/support_ticket/support_ticket_activity/SupportTicketActivity";
import SupportTicketActivityFilter from "@/modules/support_ticket_ds/internal/support_ticket/support_ticket_activity/SupportTicketActivityFilter";

import SupportTicketHistoric from "@/modules/support_ticket_ds/internal/support_ticket/support_ticket_historic/SupportTicketHistoric";
import SupportTicketHistoricFilter from "@/modules/support_ticket_ds/internal/support_ticket/support_ticket_historic/SupportTicketHistoricFilter";

import SupportTicketInternship from "@/modules/support_ticket_ds/internal/support_ticket/support_ticket_internship/SupportTicketInternship";

export default {
  name: "SupportTicketContainer",
  components: { wtForm, SupportTicket, SupportTicketFilter, 
                SupportTicketActivity, SupportTicketActivityFilter,
                SupportTicketHistoric, SupportTicketHistoricFilter,
                SupportTicketInternship
              },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    }
  },

  data: function() {
    return {
      tabIndex: null,
      supportTicket: null,

      /* Others Finds */
      ticketTypes: [{ value: null, text: "---" }],
      ticketClassification: [{ value: null, text: "---" }],
      ticketPriority: [{ value: null, text: "---" }],
      ticketStatus: [{ value: null, text: "---" }],
      productType: [{ value: null, text: "---" }],
      productModule: [{ value: null, text: "---" }],
      productFunction: [{ value: null, text: "---" }]
    };
  },
  methods: {
    alterTabFocus() {
      this.$nextTick(() => {
        this.tabIndex++;
      });
    },

    getTicketTypes() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-ticket-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.ticketTypes.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getTicketClassification() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-ticket-classification`
        )
        .then(res => {
          res.data.forEach(element => {
            this.ticketClassification.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getTicketPriority() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-ticket-priority`
        )
        .then(res => {
          res.data.forEach(element => {
            this.ticketPriority.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getTicketStatus() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-ticket-status`
        )
        .then(res => {
          res.data.forEach(element => {
            this.ticketStatus.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getProductType() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-product-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.productType.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getProductModule() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-product-module`
        )
        .then(res => {
          res.data.forEach(element => {
            this.productModule.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },

    getProductFunction() {
      const urlService = "support-ticket-ds/api/internal/support-ticket";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-product-function`
        )
        .then(res => {
          res.data.forEach(element => {
            this.productFunction.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    }
  },
  watch: {
    tabIndex() {
      if(this.tabIndex === 0) {
        this.$store.commit("setUrlServicesStore","support-ticket-ds/api/internal/support-ticket")
        this.$store.commit('setObjFilter', {}) 
        this.$store.commit('setObjSelected', {})
        this.$store.commit("setShowGrid", true);
        this.$store.commit('setResetFilter', false)
        this.$store.commit('setApplyFilter', false)   
        this.$store.commit("setShowFilter", true);         
      }

      if(this.tabIndex === 1) {
        this.$store.commit("setUrlServicesStore","support-ticket-ds/api/internal/support-ticket-activity")
        this.$store.commit("setObjFilter", {});
        this.$store.commit("setShowGrid", true);
        this.$store.commit("setResetFilter", false);
        this.$store.commit("setApplyFilter", false);   
        this.$store.commit("setShowFilter", true);  
        this.$store.commit("setAction", "initial");    
      }
      
      if(this.tabIndex === 2) {
        this.$store.commit("setUrlServicesStore","support-ticket-ds/api/internal/support-ticket-historic")
        this.$store.commit("setObjFilter", {});
        this.$store.commit("setShowGrid", true);
        this.$store.commit("setResetFilter", false);
        this.$store.commit("setApplyFilter", false);   
        this.$store.commit("setShowFilter", true);      
      }

      if(this.tabIndex === 3) {
        this.$store.commit("setUrlServicesStore","support-ticket-ds/api/internal/support-ticket-internship")
        this.$store.commit("setObjFilter", {});
        this.$store.commit("setShowGrid", true);
        this.$store.commit("setResetFilter", false);
        this.$store.commit("setApplyFilter", false);
        this.$store.commit("setShowFilter", false);  
      }
    },
  },
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "streamline-ds/api/internal/resource"
    );
  },
  mounted() {
    this.getTicketTypes();
    this.getTicketClassification();
    this.getTicketPriority();
    this.getTicketStatus();
    this.getProductType();
    this.getProductModule();
    this.getProductFunction();
  },
  update(){
   
  },
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>
